const ContentfulTypes = Object.freeze({
  TEST_ABANDONMENT_OVERLAY: 'testAbandonmentOverlay',
  PLATFORM_FEATURES: 'platformFeatures',
  MARKETING_PAGES: 'marketPages',
});

export default ContentfulTypes;
